<template>
  <div class="createads-cnt">
    <header class="inner-header">
      <backIcon />
      <h2> 
        {{$t('Your business promotion in 3 clicks')}}
      </h2>
      <p>{{$t('My main Goal is')}} :</p>
    </header>
    <section class="mid-cnt">
      <div class="ctg-list">
        <ul> 
          <li @click="$router.push('/pincode?intent=WHATS_APP_OPEN&MediaType=1')">
            <span class="icon-box">
              <img src="../assets/images/ctg-whats.svg" />
            </span>
            <span class="txt-title">
             {{$t('Get Customers on WhatsApp')}}
            </span>
            <incrementArrowIcon />
          </li>

          <li @click="$router.push('/pincode?intent=CALL_START&MediaType=1')">
            <span class="icon-box">
              <img src="../assets/images/ctg-phone.svg" />
            </span>
            <span class="txt-title">
              {{$t('Gets Customers on Call')}}
            </span>
            <incrementArrowIcon />
          </li>

          <li @click="$router.push('/pincode?intent=LINK_OPEN&MediaType=1')">
            <span class="icon-box">
              <img src="../assets/images/ctg-online.svg" />
            </span>
            <span class="txt-title">
             {{$t('Get Customers Online')}}
            </span>
            <incrementArrowIcon />
          </li>

          <li @click="$router.push('/pincode?intent=WHATS_APP_OPEN&MediaType=4')">
            <span class="icon-box"> 
              <img src="../assets/images/customer-converts.svg" />
            </span>
            <span class="txt-title">
              {{$t('Get Customers Leads')}}
            </span>
            <incrementArrowIcon />
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>
<script>
import backIcon from "../components/icons/backIcon";
import incrementArrowIcon from "../components/icons/incrementArrowIcon";
export default {
  name: "CreateAd",
  components: {
    backIcon,
    incrementArrowIcon,
  },
};
</script>
